import React, { useContext } from 'react';
import { MenuItem, Select } from '@mui/material';
import { updateUserLanguage } from '../services/edge/UserService';
import { Context } from '../states/Store';
import i18next from 'i18next';
import EAIcon from './common/EAIcon';
import useStyles from '../style/js-style/components/EALanguageSelectorStyle';
import { find } from 'lodash';

export const languages = [
  { label: i18next.t("userLanguages.fr"), value: "fr", muiLangCode: "frFR" },
  { label: i18next.t("userLanguages.en"), value: "en", muiLangCode: "enUS" },
  { label: i18next.t("userLanguages.de"), value: "de", muiLangCode: "deDE" },
  { label: i18next.t("userLanguages.it"), value: "it", muiLangCode: "itIT" },
  { label: i18next.t("userLanguages.pt"), value: "pt", muiLangCode: "ptPT" },
  { label: i18next.t("userLanguages.nl"), value: "nl", muiLangCode: "nlNL" },
  { label: i18next.t("userLanguages.es"), value: "es", muiLangCode: "esES" },
]

const RenderSelectedLanguage = ({selected}) => {
  const { classes } = useStyles();
  const lang = find(languages, { value: selected });

  return (
    <div className={classes.itemWrapper}>
      <div className={classes.itemImageWrapper}>
        <EAIcon icon={"/flag/universal"} extension={"png"} className={classes.itemImage} />
      </div>
      {lang.label}
    </div>
  )
}

const EALanguageSelector = () => {
  const [state, dispatch] = useContext(Context);
  const { classes } = useStyles();

  const changeLanguageHandler = async (lang) => {
    try {
      await updateUserLanguage(lang);
      window.Localize.setLanguage(lang);
      localStorage.setItem('i18nextLng', lang);
      dispatch({ type: "LANG", lang: lang })
      window.location.reload();
    } catch (error) {
      console.log("error : ", error)
    }
  }

  return state.lang && (
    <Select
      id={`select-language`}
      defaultValue={state.lang || "en"}
      onChange={(event) => changeLanguageHandler(event.target.value)}
      style={{
        backgroundColor: "white",
        marginRight: "16px",
      }}
      sx={{
        border: "none",
        fontSize: '14px !important',
        borderRadius: "56px !important",
        padding: "0px 5px",
        paddingRight: "14px",
      }}
      renderValue={(selected) => (<RenderSelectedLanguage selected={selected} />)}
    >
      {/* Options des langues */}
      { languages.map((lang) => (
        <MenuItem key={lang.label} value={lang.value}>
          <div className={classes.itemWrapper}>
            {lang.label}
          </div>
        </MenuItem>
      ))}
    </Select>
  )
}

export default EALanguageSelector;
